// src/reducers/kanbanReducer.js
const initialState = {
       columns: {},
       ordered: [],
       tasks: {},
};

const kanbanReducer = ( state = initialState, action ) =>
{
       switch ( action.type )
       {
              case 'MOVE_COLUMN': {
                     return {
                            ...state,
                            ordered: action.payload,
                     };
              }
              case 'MOVE_TASK_IN_SAME_COLUMN': {
                     const { columnId, taskIds } = action.payload;
                     return {
                            ...state,
                            columns: {
                                   ...state.columns,
                                   [ columnId ]: {
                                          ...state.columns[ columnId ],
                                          taskIds,
                                   },
                            },
                     };
              }
              case 'MOVE_TASK_BETWEEN_COLUMNS': {
                     const {
                            sourceColumnId,
                            destinationColumnId,
                            sourceTaskIds,
                            destinationTaskIds,
                     } = action.payload;
                     return {
                            ...state,
                            columns: {
                                   ...state.columns,
                                   [ sourceColumnId ]: {
                                          ...state.columns[ sourceColumnId ],
                                          taskIds: sourceTaskIds,
                                   },
                                   [ destinationColumnId ]: {
                                          ...state.columns[ destinationColumnId ],
                                          taskIds: destinationTaskIds,
                                   },
                            },
                     };
              }
              default: {
                     return state;
              }
       }
};

export default kanbanReducer;
